import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../app/hooks';
import {
    tryToEditInvoice,
    tryToFetchSingleInvoice
} from '../../../../store/brokers/suppliers/invoices/InvoicesSlice';
import Button from '../../../../shared/button';
import Input from '../../../../shared/input';
import Error from '../../../../shared/error';
import Modal from '../../../../shared/modal';


interface IEditDetailsModal {
    openModal: boolean;
    invoiceId: string;
    handleCloseModal: () => void;
}

const EditDetailsModal = ({
    openModal,
    invoiceId,
    handleCloseModal,
}: IEditDetailsModal) => {
    const dispatch = useAppDispatch();
    const [shippingCosts, setShippingCosts] = useState<any>();
    const [totalAmount, setTotalAmount] = useState<any>();
    const [generalError, setGeneralError] = useState<string>();
    const state = useAppSelector((state) => state?.invoices);

    useEffect(() => {
        setShippingCosts(state?.invoiceDetails?.invoiceInfo?.shippingCosts)
        setTotalAmount(state?.invoiceDetails?.invoiceInfo?.totalAmount)
    }, [state?.invoiceDetails])

    useEffect(() => {
        if (invoiceId) {
            dispatch(tryToFetchSingleInvoice(invoiceId || ''))
        } else {
            setShippingCosts(undefined)
            setTotalAmount(undefined)
        }
    }, [invoiceId, openModal])

    const onCloseModal = () => {
        handleCloseModal()
        setTotalAmount(undefined)
        setGeneralError(undefined)
        setShippingCosts(undefined)
    }

    const onSubmitEdit = async () => {
        try {
            const formData = {
                totalAmount: totalAmount,
                shippingCosts: shippingCosts
            }
            await dispatch(tryToEditInvoice({ id: invoiceId, data: formData })).unwrap();
            setGeneralError(undefined)
            onCloseModal()
        } catch (err) {
            setGeneralError(`${err}`)
        }
    }

    const onChangeInputValue = (value: any, type: string) => {
        if (type === 'shipping') {
            setShippingCosts(value)
        } else {
            setTotalAmount(value)
        }
    }

    return (
        <Modal
            open={openModal}
            showInRight
            title={'Edit Info'}
            onClose={() => handleCloseModal()}
        >
            <div className={'p-2 min-w-[500px]'}>
                <div className='border-b-2 border-slate-200 pb-2 my-1'>
                    <p className='font-medium text-slate-700'>Edit Info</p>
                </div>
                {generalError && <Error text={generalError} />}
                <div className='p-2 !rounded bg-[#f8f9fc]'>
                    <div>
                        <Input
                            label='Shipping Costs'
                            showValue={true}
                            inputValue={shippingCosts}
                            containerStyle='max-w-[90%]'
                            inputUniqueName='shipping'
                            onChangeInput={onChangeInputValue}
                        />
                        <Input
                            label='Total Amount'
                            showValue={true}
                            inputValue={totalAmount}
                            containerStyle='max-w-[90%]'
                            inputUniqueName='totalAmount'
                            onChangeInput={onChangeInputValue}
                        />
                    </div>
                    <div className='flex flex-row justify-center my-10'>
                        <Button
                            label='Submit'
                            dataQa={'continue-button'}
                            className={'btn-primary min-w-[150px]'}
                            onClickButton={() => onSubmitEdit()}
                        />
                    </div>
                </div>
            </div>
        </Modal>
    )
}
export default EditDetailsModal;